import { useTranslation } from 'react-i18next';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { type MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import LanguageSelector from '../../../../LanguageSelector';

export function useLanguageItem(): (MenuItem & { key: string }) | false {
  const { t } = useTranslation();

  return {
    key: 'language-selector',
    label: t('siteHeader.userMenu.languageSelector.label'),
    suffix: <LanguageSelector withText />,
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      menu_name: 'profile',
      menu_item: 'language',
    }),
  };
}
